import React from "react";
import { connect } from 'react-redux';
import { Preloading as preloading } from '../../../components/UI/Preloader/action';
import { CardBody, Card, Label, Form,Row, FormGroup, Col, Button, Input, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import Modal from "../../../components/UI/Modal/Modal";
import Select from 'react-select'
import { toast } from 'react-toastify';
import fileSaver from 'file-saver';
import moment from 'moment';
import { downloadMonitoringCounterpartyDataRequest, fetchMonitoringListRequest, createMonitoringMetaDataRequest, startMonitoringProcessRequest, uploadMonitoringTemplateRequest } from "./action";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const DATE_FORMAT = 'dd-MMM-YYYY';
const PLACE_HOLDER = 'DD-MMM-YYYY';
const monthData = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

class Monitoring extends React.Component {


    state = {
        monitoringData: [],
        selectedOption: undefined,
        toDate: null,
        fromDate: null,
        monitoringFile: undefined,
        modal: false,
        monitoringName: undefined,
        monitoringMonth: null,
        monitoringTemplateFile: null,
        monitoringDate : undefined
    };

    handleFromDateChange = (date) => {
        this.setState({ fromDate: date })
    }

    handleToDateChange = (date) => {
        this.setState({ toDate: date })
    }

    getMonths = (d2, d1) => {
        let months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
    }

    downloadData = (e) => {
        e.preventDefault();
        let date1 = new Date(this.state.fromDate);
        let date2 = new Date(this.state.toDate);
        let months = this.getMonths(date2, date1);
        if (date1.getTime() >= date2.getTime()) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select <b>Appropriate </b>Period !
                </div>
            );
        }/*  else if (months <= 3) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select at least 3 months period !
            </div>)
        } */ else if (months > 12) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please select maximum 12 months period!
                </div>
            );
        } else {
            this.props.preloading(true);
            this.props.downloadMonitoringCounterpartyDataRequest({ fromDate: moment(this.state.fromDate).format('DD-MM-YYYY').toString(), toDate: moment(this.state.toDate).format('DD-MM-YYYY').toString() })
        }
    }

    handleChange = (option) => {
        this.setState({ selectedOption: option })
    }

    componentDidMount() {
        this.props.fetchMonitoringListRequest();
    }

    uploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({ monitoringFile: file });
        } else {
            this.setState({ monitoringFile: undefined });
            e.target.value = null;
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Excel File only !
                </div>
            );
        }
        e.target = null;
    }

    uploadTemplateFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && file.name.endsWith(".xlsx")) {
            this.setState({ monitoringTemplateFile: file });
        } else {
            this.setState({ monitoringTemplateFile: undefined });
            e.target.value = null;
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload Excel File only !
                </div>
            );
        }
        e.target = null;
    }

    prepareMonitoringPeriod = (date) => {
        let date1 = new Date(date);
        let todayMonth = date1.getMonth();
        let todayYear = date1.getFullYear();
        let monitoringDate = date1.getDate()+"-"+monthData[todayMonth]+"-"+todayYear;
        this.setState({ monitoringName: `${monthData[todayMonth]}-${todayYear}`, monitoringMonth: date, monitoringDate : monitoringDate })
    }

    createMonitoringName = (e) => {
        e.preventDefault();
        this.props.preloading(true);
        this.toggle();
        let index = 0;
        for (index = 0; index < this.state.monitoringData.length; index++) {
            if (this.state.monitoringData[index].label == this.state.monitoringName) {
                this.props.preloading(false);
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Monitoring Name already exist !
                    </div>
                );
                return;
            }
        }
        this.props.createMonitoringMetaDataRequest({ monitoringName: this.state.monitoringName, monitoringDate : this.state.monitoringDate })
    }

    submitDataToServer = (e) => {
        e.preventDefault();
        this.props.startMonitoringProcessRequest({
            file: this.state.monitoringFile,
            monitoringId: this.state.selectedOption.value
        })
        this.props.preloading(true);
    }

    submitTemplateToServer = (e) => {
        e.preventDefault();
        this.props.uploadMonitoringTemplateRequest({
            file: this.state.monitoringTemplateFile,
            monitoringId: this.state.selectedOption.value
        })
        this.props.preloading(true);
    }

    componentDidUpdate(prevProps) {
        if (this.props.monitoringList !== prevProps.monitoringList) {
            let monitoringNameOptions = [];
            this.props.monitoringList && this.props.monitoringList.length > 0 &&
                this.props.monitoringList.map(monitoringObj => (
                    monitoringNameOptions = [
                        ...monitoringNameOptions, {
                            value: monitoringObj.id, label: monitoringObj.monitoringName
                        }
                    ]
                ))
            this.setState({ monitoringData: monitoringNameOptions, selectedOption: monitoringNameOptions.length > 0 ? monitoringNameOptions[0] : undefined })
        }
        if (this.props.monitoringCounterpartyData !== prevProps.monitoringCounterpartyData) {
            this.props.preloading(false);
            if (this.props.monitoringCounterpartyData.status === "SUCCESS") {
                const data = this.props.monitoringCounterpartyData.data;
                let blob = new Blob([data], { type: 'application/octet-stream' });
                fileSaver.saveAs(blob, `${"monitoring_data"}_${moment().format("DD_MMM_YYYY")}.xlsx`)
            } else if (this.props.monitoringCounterpartyData.status === "FAILURE") {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Please Try again !!
                    </div>
                );
            }
        }
        if (this.props.monitoringMetadataResponse !== prevProps.monitoringMetadataResponse) {
            this.props.preloading(false);
            if (this.props.monitoringMetadataResponse.status === "SUCCESS") {
                this.props.fetchMonitoringListRequest();
                toast.success(
                    <div>
                        <i ></i>&nbsp; Monitoring Name created Successfully !
                    </div>
                );
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>Something went wrong, Please Try again !!
                    </div>
                );
            }
        }
        if (this.props.monitoringProcess !== prevProps.monitoringProcess) {
            this.props.preloading(false);
            if (this.props.monitoringProcess.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Monitoring started Successfully !
                    </div>
                );
                this.setState({ monitoringFile: undefined });
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.monitoringProcess.data.message}
                    </div>
                );
            }
        }
        if(this.props.templateUpload !== prevProps.templateUpload) {
            this.props.preloading(false);
            if (this.props.templateUpload.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Template Uploaded Successfully !
                    </div>
                );
                this.setState({ monitoringTemplateFile: undefined });
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.templateUpload.data.message}
                    </div>
                );
            }
        }
    }

    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }

    handleNameChange = (e) =>{
        e.preventDefault();
        this.setState({ monitoringName : e.target.value})
    }

    render() {
        return (<Col>
            <div className="justify-content-between align-items-center mb-3">
                <h4 className="mb-0 text-center">Data Monitoring</h4>
            </div>
            <Card>
                <CardBody >
                    <Form className="w-100" >
                        <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={3}>Date Range</Label>

                            <Col sm={5} className="filter-category p-3 py-sm-0">

                                <div className="filter-options">
                                    <div name="fromDate" className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">From</span> <DatePicker placeholderText={PLACE_HOLDER} selected={this.state.fromDate} onChange={this.handleFromDateChange} dateFormat={DATE_FORMAT} /></div>
                                    <div className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">To</span> <DatePicker placeholderText={PLACE_HOLDER} selected={this.state.toDate} onChange={this.handleToDateChange} dateFormat={DATE_FORMAT} /></div>
                                </div>
                            </Col>

                            <Col sm={13}>
                                <Button color="primary" disabled={this.state.toDate === null || this.state.fromDate === null} onClick={(e) => this.downloadData(e)} > Download Corporate and Counterparty Data </Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </CardBody>
            </Card>

            <Card>
                <CardBody >
                    <Form className="w-100" >
                        <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={6}>Monitoring Name </Label>
                            <Col sm={10}>
                                <Select
                                    value={this.state.selectedOption}
                                    onChange={this.handleChange}
                                    options={this.state.monitoringData} />
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={6}>
                                <Button color="primary" onClick={(e) => this.setState({ modal: true })}>Create </Button>
                            </Col>
                        </FormGroup>
                        <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={6}>Upload Input File </Label>
                            <Col sm={10}>
                                <Input type="file" name="monitoring-data-file" id="monitoring-data-file" onChange={(e) => this.uploadFile(e)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={6}>
                                <Button disabled={!this.state.selectedOption || !this.state.monitoringFile} color="primary" onClick={(e) => this.submitDataToServer(e)} > Save Data </Button>
                            </Col>
                        </FormGroup>
                        {/* <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={6}>Select Template File </Label>
                            <Col sm={10}>
                                <Input type="file" name="monitoring-template-file" id="monitoring-template-file" onChange={(e) => this.uploadTemplateFile(e)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                            </Col>
                            <Col style={{ marginLeft: "1rem" }} sm={6}>
                                <Button disabled={!this.state.selectedOption || !this.state.monitoringTemplateFile} color="primary" onClick={(e) => this.submitTemplateToServer(e)} > Submit Template </Button>
                            </Col>
                        </FormGroup> */}

                        {/*  <FormGroup style={{ marginLeft: "1rem" }} row>
                            <Label sm={14}></Label>
                            <Col sm={6}>
                                <Button disabled={!this.state.selectedOption || !this.state.monitoringFile} color="primary" onClick={(e) => this.submitDataToServer(e)} > Submit Data </Button>
                            </Col>
                        </FormGroup> */}
                    </Form>
                </CardBody>
            </Card>


            <Modal show={this.state.modal} className="legal-confirm-modal Large-Modal monitoring-name-modal" >
                <ModalHeader toggle ={this.toggle}>
                    Create Monitoring Name
                </ModalHeader>
                <ModalBody>
                    <div className="d-flex justify-content-between filter-datepicker"><span className="filter-datepicker-label">Monitoring Date</span> <DatePicker placeholderText={DATE_FORMAT} selected={this.state.monitoringMonth} onChange={this.prepareMonitoringPeriod} dateFormat={DATE_FORMAT} /></div>
                   <Row>
                       <Col style ={{marginTop : "0.5rem"}}>Monitoring Name</Col>
                       <Col><Input name ="monitoringName"  value = {this.state.monitoringName ? this.state.monitoringName : ""} onChange = {e=> this.handleNameChange(e)}/></Col>
                   </Row>
                </ModalBody>
                <ModalFooter>
                    {this.state.monitoringName && <Button color="info" > {this.state.monitoringName}</Button>}{' '}
                    <Button disabled={!this.state.monitoringName || !this.state.monitoringDate} color="secondary" onClick={e => this.createMonitoringName(e)}>Create</Button>
                </ModalFooter>
            </Modal>
        </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    monitoringCounterpartyData: state.monitoringData.monitoringCounterpartyData,
    monitoringList: state.monitoringData.monitoringList,
    monitoringMetadataResponse: state.monitoringData.monitoringMetadataResponse,
    monitoringProcess: state.monitoringData.monitoringProcess,
    templateUpload: state.monitoringData.templateUpload
})

const mapDispatchToProps = (dispatch) => ({
    preloading: data => { dispatch(preloading(data)) },
    downloadMonitoringCounterpartyDataRequest: data => { dispatch(downloadMonitoringCounterpartyDataRequest(data)) },
    fetchMonitoringListRequest: (data) => { dispatch(fetchMonitoringListRequest(data)) },
    createMonitoringMetaDataRequest: data => { dispatch(createMonitoringMetaDataRequest(data)) },
    startMonitoringProcessRequest: data => { dispatch(startMonitoringProcessRequest(data)) },
    uploadMonitoringTemplateRequest: data => {dispatch(uploadMonitoringTemplateRequest(data))}
});

export default connect(mapStateToProps, mapDispatchToProps)(Monitoring);